let mainHost: string = (location.hostname == 'localhost')? 'http://'+location.hostname+':'+location.port : 'https://'+location.hostname;

let apiHost: string|undefined = process.env.VUE_APP_ENV_APIHOST;// set apiHost

if (apiHost == undefined) {
    apiHost = 'https://api.virtual-wallet.jp';
}
let indexQrHost: string|undefined = process.env.VUE_APP_ENV_INDEXQRHOST;// set apiHost
if (indexQrHost == undefined) {
    indexQrHost = 'https://virtual-wallet.jp';
}
let blockchainEnv: string|undefined = process.env.VUE_APP_ENV_STATUS;
if (blockchainEnv == undefined) {
    blockchainEnv = 'main';
}
let blockchainEnvName: any;
let blockchainHost: any;
let addressRules: any;
if (blockchainEnv == 'main') {
    blockchainEnvName = {
        Bitcoin: 'livenet',
        Ethereum: 'mainnet',
        Ripple: 'mainnet'
    }
    blockchainHost = {
        Bitcoin: 'mainnet',
        Ethereum: 'https://mainnet.infura.io/v3/'+process.env.VUE_APP_ENV_INFURA_API_KEY,
        Ripple: 'wss://s1.ripple.com:443'
    }
    addressRules = {
        Bitcoin: ['1', '3'],
        Ethereum: '0x',
        Ripple: ['r', 'X']
    }
} else if (blockchainEnv == 'test') {
    blockchainEnvName = {
        Bitcoin: 'testnet',
        Ethereum: 'ropsten',
        Ripple: 'testnet'
    }
    blockchainHost = {
        Bitcoin: 'testnet',
        Ethereum: 'https://ropsten.infura.io/v3/'+process.env.VUE_APP_ENV_INFURA_API_KEY, // test
        // Ethereum: 'http://127.0.0.1:8545', // develop
        Ripple: 'wss://s.altnet.rippletest.net:51233'
    }
    addressRules = {
        Bitcoin: ['m','n','2'],
        Ethereum: '0x',
        Ripple: ['r', 'T']
    }
}
// お知らせ下部に掲載するページ内リンク
const newsLink = {
    backup_favor: {
        link: 'optionBackup',
        text: '→ バックアップはコチラから'
    }
}
const projectName = 'VUILÐERLAND';
const orgTokenName = 'VUIL Token';
const orgTokenSymbol = 'VUIL';
const pointSymbol = 'VP';
// developStatus 0:公開中,1:メンテナンス中,2:開発中
const pageInfo = [
    // アプリケーションページ
    // アカウント作成ページ
    {
        name: 'startPin1',
        title: 'STEP.2　暗証番号の設定',
        prevPage: 'start',
        developStatus: 0
    },
    {
        name: 'startPin2',
        title: 'STEP.3　暗証番号の確認',
        prevPage: 'startPin1',
        developStatus: 0
    },
    {
        name: 'startApply',
        title: 'STEP.4　規約の同意',
        prevPage: 'startPin2',
        developStatus: 0
    },
    // 復元ページ
    {
        name: 'startRestoreMnemonic',
        title: 'ウォレットの復元',
        prevPage: 'start',
        developStatus: 0
    },
    {
        name: 'startRestorePin1',
        title: 'ウォレットの復元',
        prevPage: 'startRestoreMnemonic',
        developStatus: 0
    },
    {
        name: 'startRestorePin2',
        title: 'ウォレットの復元',
        prevPage: 'startRestorePin1',
        developStatus: 0
    },
    {
        name: 'startRestoreApply',
        title: 'ウォレットの復元',
        prevPage: 'startRestorePin2',
        developStatus: 0
    },

    /**
     * token
     */
    {
        name: 'token',
        title: 'logo', // ロゴ表示
        prevPage: null,
        developStatus: 0
    },
    {
        name: 'tokenSetting',
        title: '通貨表示設定',
        prevPage: 'token',
        developStatus: 0
    },
    // token/transfer
    {
        name: 'tokenTransfer',
        title: '送金する',
        prevPage: 'token',
        developStatus: 0
    },
    {
        name: 'tokenTransferPin',
        title: '送金する',
        prevPage: 'tokenTransfer',
        prevParams: ['name'],
        developStatus: 0
    },
    // token/address
    {
        name: 'tokenAddress',
        title: '受け取る',
        prevPage: 'token',
        developStatus: 0
    },
    // token/:name
    {
        name: 'tokenInfo',
        title: '詳細情報',
        prevPage: 'token',
        developStatus: 0
    },
    {
        name: 'tokenInfoKey',
        title: '詳細情報',
        prevPage: 'tokenInfo',
        prevParams: ['name'],
        developStatus: 0
    },
    {
        name: 'tokenInfoKeyPin',
        title: '詳細情報',
        prevPage: 'tokenInfoKey',
        prevParams: ['name'],
        developStatus: 0
    },
    {
        name: 'tokenInfoKeyShow',
        title: '詳細情報',
        prevPage: 'tokenInfoKeyPin',
        prevParams: ['name'],
        developStatus: 0
    },
    // agentTransfer
    {
        name: 'tokenAgentTransfer',
        title: 'エージェントトランスファー',
        prevPage: 'token',
        developStatus: 2
    },
    // friends
    {
        name: 'tokenFriends',
        title: '送信先',
        prevPage: 'token',
        developStatus: 0
    },
    {
        name: 'tokenFriendsInfo',
        title: '送信先',
        prevPage: 'tokenFriends',
        developStatus: 0
    },
    {
        name: 'tokenFriendsTransfer',
        title: '送信先',
        prevPage: 'tokenFriendsInfo',
        developStatus: 0
    },
    {
        name: 'tokenFriendsTransferPin',
        title: '送信先',
        prevPage: 'tokenFriendsTransfer',
        developStatus: 0
    },
    {
        name: 'tokenFriendsAdd',
        title: '送信先',
        prevPage: 'tokenFriends',
        developStatus: 0
    },
    {
        name: 'tokenFriendsEdit',
        title: '送信先',
        prevPage: 'tokenFriends',
        developStatus: 0
    },

    /**
     * works 廃止
     */
    {
        name: 'works',
        title: 'ワークス',
        prevPage: null,
        developStatus: 2
    },
    {
        name: 'workList',
        title: '案件一覧',
        prevPage: 'works',
        developStatus: 2
    },
    /**
     * builder
     */
    {
        name: 'builder',
        title: 'NFTビルダー',
        prevPage: null,
        developStatus: 2
    },
    {
        name: 'builderCreate',
        title: 'NFTの作成',
        prevPage: 'builder',
        developStatus: 2
    },
    {
        name: 'builderConfirm',
        title: 'NFTの確認',
        prevPage: 'builderCreate',
        developStatus: 2
    },
    /**
     * square
     */
    {
        name: 'square',
        title: projectName,
        prevPage: null,
        developStatus: 2
    },
    /**
     * option
     */
    {
        name: 'option',
        title: '設定',
        prevPage: null,
        developStatus: 0
    },
    {
        name: 'optionHowto',
        title: 'ウォレットの使い方',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionRules',
        title: '利用規約',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionRulesWorks',
        title: 'ワークス機能利用規約',
        prevPage: 'optionRules',
        developStatus: 0
    },
    {
        name: 'optionAbout',
        title: 'Virtual Walletについて',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionFaq',
        title: 'よくある質問',
        prevPage: 'option',
        developStatus: 0
    },
    // option/backup
    {
        name: 'optionBackup',
        title: 'バックアップ',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionBackupPin',
        title: 'バックアップ',
        prevPage: 'optionBackup',
        developStatus: 0
    },
    {
        name: 'optionBackupMnemonic',
        title: 'バックアップ',
        prevPage: 'optionBackupPin',
        developStatus: 0
    },
    // option/pin
    {
        name: 'optionPin',
        title: '暗証番号の再設定',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionPinCurrent',
        title: '暗証番号の再設定',
        prevPage: 'optionPin',
        developStatus: 0
    },
    {
        name: 'optionPinReset1',
        title: '暗証番号の再設定',
        prevPage: 'optionPinCurrent',
        developStatus: 0
    },
    {
        name: 'optionPinReset2',
        title: '暗証番号の再設定',
        prevPage: 'optionPinReset1',
        developStatus: 0
    },
    // option/import
    {
        name: 'optionImport',
        title: '通貨のインポート',
        prevPage: 'option',
        developStatus: 0
    },
    {
        name: 'optionImportAdd',
        title: '通貨のインポート',
        prevPage: 'optionImport',
        developStatus: 0
    },
    {
        name: 'optionImportAddPin',
        title: '通貨のインポート',
        prevPage: 'optionImportAdd',
        developStatus: 0
    },
    {
        name: 'optionImportInfo',
        title: '詳細情報',
        prevPage: 'optionImport',
        developStatus: 0
    },
    {
        name: 'optionImportInfoKey',
        title: '詳細情報',
        prevPage: 'optionImportInfo',
        prevParams: ['name'],
        developStatus: 0
    },
    {
        name: 'optionImportInfoKeyPin',
        title: '詳細情報',
        prevPage: 'optionImportInfoKey',
        prevParams: ['name'],
        developStatus: 0
    },
    {
        name: 'optionImportInfoKeyShow',
        title: '詳細情報',
        prevPage: 'optionImportInfoKeyPin',
        prevParams: ['name'],
        developStatus: 0
    },
];

const toDoubleDigits = function(num: string) {
    num += "";
    if (num.length === 1) {
        num = "0" + num;
    }
    return num;
}

/**
 * UTCの現在の時刻を返す
 */
const getNow = function() {

    const nowDate: any = new Date(Date.now());
    const year: string = nowDate.getFullYear();
    const month: string = toDoubleDigits((nowDate.getMonth() + 1).toString());
    const day: string = toDoubleDigits(nowDate.getDate());
    const hours: string = toDoubleDigits(nowDate.getHours());
    const minutes: string = toDoubleDigits(nowDate.getMinutes());

    return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes;
}
/**
 * UTCの現在の日付を返す
 */
const getToday = function() {
    const nowDate: any = new Date(Date.now());
    const year: string = nowDate.getFullYear();
    const month: string = toDoubleDigits((nowDate.getMonth() + 1).toString());
    const day: string = toDoubleDigits(nowDate.getDate());

    return year + '-' + month + '-' + day;
}

const defaultTimezone = 'Asia/Tokyo';

const countryNames: any = {
    JPN: '日本',
    USA: 'アメリカ合衆国',
    etc: 'その他の地域'
};

const workableCountries: any = [
    'JPN'
];

let defaultTokenList: any = [];
if (blockchainEnv == 'main') {
    defaultTokenList = [
        {
            name: 'Tether USD',
            address: '0xdac17f958d2ee523a2206206994597c13d831ec7'
        },
        {
            name: 'Uniswap Token',
            address: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984'
        },
        {
            name: 'ChainLink Token',
            address: '0x514910771af9ca656af840dff83e8264ecf986ca'
        }
    ];
} else if (blockchainEnv == 'test') {
    defaultTokenList = [
        {
            name: 'Tether USD',
            address: '0x6ee856ae55b6e1a249f04cd3b947141bc146273c'
        },
        {
            name: 'Uniswap Token',
            address: '0xc8f88977e21630cf93c02d02d9e8812ff0dfc37a'
        },
        {
            name: 'ChainLink Token',
            address: '0x20fe562d797a42dcb3399062ae9546cd06f63280'
        },
        {
            name: 'VUILTOKEN',
            address: '0xbaF34A33B08b97775D812F2969bE87772a38Dd30'
        }
    ];
}

const serviceList: any = [
    {id: 1, name: '資料請求・懸賞・コミュニティ'},
    {id: 2, name: '月額サービス'},
    {id: 3, name: '金融・投資・保険'},
    {id: 4, name: '不動産投資'},
    {id: 5, name: '動画・電子書籍・音楽'},
    {id: 6, name: '通信・Wifi・ネットワーク回線'},
    {id: 7, name: '生活・お役立ちサービス'},
    {id: 8, name: '旅行・ホテル・航空券・乗り物'},
];

const shoppingList: any = [
    {id: 21, name: '総合通販・買取・チケット'},
    {id: 22, name: '化粧品・スキンケア・美容・エステ'},
    {id: 23, name: 'ファッション'},
    {id: 24, name: 'バッグ・小物・時計'},
    {id: 25, name: '家電・日用品・文具'},
    {id: 26, name: '食品・ドリンク・お酒'},
    {id: 27, name: 'スポーツ・フィットネス・アウトドア'},
    {id: 28, name: 'ゲーム・ホビー・楽器'},
    {id: 29, name: 'ペット・お花・ガーデニング'},
    {id: 30, name: '車・バイク・その他'},

];

export default {
    mainHost: mainHost,
    apiHost: apiHost,
    indexQrHost: indexQrHost,
    newsLink: newsLink,
    projectName: projectName,
    orgTokenName: orgTokenName,
    orgTokenSymbol: orgTokenSymbol,
    pointSymbol: pointSymbol,
    pageInfo: pageInfo,
    blockchainEnv: blockchainEnv,
    blockchainEnvName: blockchainEnvName,
    blockchainHost: blockchainHost,
    addressRules: addressRules,
    utcNow: getNow,
    utcToday: getToday,
    defaultTimezone: defaultTimezone,
    countryNames: countryNames,
    workableCountries: workableCountries,
    defaultTokenList: defaultTokenList,
    serviceList: serviceList,
    shoppingList: shoppingList
}
